import { render, staticRenderFns } from "./InspectionsSection.vue?vue&type=template&id=6d1b038e&scoped=true"
import script from "./InspectionsSection.ts?vue&type=script&lang=ts&external"
export * from "./InspectionsSection.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1b038e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d1b038e')) {
      api.createRecord('6d1b038e', component.options)
    } else {
      api.reload('6d1b038e', component.options)
    }
    module.hot.accept("./InspectionsSection.vue?vue&type=template&id=6d1b038e&scoped=true", function () {
      api.rerender('6d1b038e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Cups/components/tabs/GeneralTab/InspectionsSection/InspectionsSection.vue"
export default component.exports